var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3938"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3794"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.622 3.003H3.376a.391.391 0 0 0-.391.391v15.212a.391.391 0 0 0 .391.392h15.246a.391.391 0 0 0 .391-.39V3.395a.391.391 0 0 0-.391-.392zm-.391 15.212H3.766V3.786h14.466v14.432zM6.809 7.625h8.012a.391.391 0 1 0 0-.781H6.809a.391.391 0 1 0 0 .781zm0 3.764h8.012a.391.391 0 1 0 0-.781H6.809a.391.391 0 0 0 0 .781zm0 3.764h8.012a.39.39 0 0 0 0-.78H6.809a.39.39 0 1 0 0 .781z",
    "data-name": "header-icon-work order"
  })))));
};
export default SvgReport;